import { CheckCircle2 } from 'lucide-react';
import { Logo } from '../components/Logo';
import type { ReactNode } from 'react';

const POINTS = [
  'Connect Shopify, WooCommerce or any custom store',
  'Recover abandoned checkouts on WhatsApp',
  'Automate support with AI grounded in your catalog',
];

export function AuthLayout({
  title,
  subtitle,
  footer,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="auth-layout">
      <aside className="auth-layout__aside">
        <div className="auth-layout__pitch">
          <h2 className="auth-layout__headline">
            Commerce automation that works across every store you run.
          </h2>
          <ul className="auth-layout__points">
            {POINTS.map((p) => (
              <li key={p} className="auth-layout__point">
                <CheckCircle2 className="auth-layout__point-icon" size={18} />
                {p}
              </li>
            ))}
          </ul>
        </div>
        <p className="auth-layout__fineprint">© {new Date().getFullYear()} Cartly360</p>
      </aside>
      <main className="auth-layout__main">
        <div className="auth-card">
          <Logo variant="logo" className="auth-card__logo" />
          <h1 className="auth-card__title">{title}</h1>
          {subtitle ? (
            <p className="auth-card__subtitle">{subtitle}</p>
          ) : (
            <div className="auth-card__spacer" />
          )}
          {children}
          {footer && <div className="auth-card__footer">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
